import {
  type listing_bool_exp,
  whereListingIsActive,
} from '@vrplatform/graphql';

export function whereLegacyListingIsExcluded(
  automationId: string | string[]
): listing_bool_exp {
  return {
    ...whereListingIsActive(),
    _not: {
      settingsRight: {
        key: {
          _eq: 'exclude',
        },
        automationId: Array.isArray(automationId)
          ? { _in: automationId }
          : {
              _eq: automationId,
            },
        value: {
          _eq: 'true',
        },
      },
    },
  };
}
